// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/common/loadingBanner/loadingBanner.scss
// module id = 802
// module chunks = 0